import { render, staticRenderFns } from "./DiagnosisMainButtons.vue?vue&type=template&id=a244e852&scoped=true&"
import script from "./DiagnosisMainButtons.vue?vue&type=script&lang=js&"
export * from "./DiagnosisMainButtons.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisMainButtons.vue?vue&type=style&index=0&id=a244e852&lang=scss&scoped=true&"
import style1 from "./DiagnosisMainButtons.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a244e852",
  null
  
)

export default component.exports